<template>
    <button @click="toggleQrModal" :disabled="prize.type === 'tickets'" class="flex flex-col px-2 justify-between w-40 h-64 md:w-64 md:h-96 bg-cover bg-center border-b bg-prize-cover rounded-md border-2 border-racing-stars-yellow border-opacity-0 my-2 mx-1 md:mx-0 md:mr-3 transition ease-in-out delay-150 hover:scale-105 col-span-1 shadow-2xl">
        <h1 class="text-center mt-3 font-semibold w-full">{{ prize.named }}</h1>
        <img :src="'images/prizes/' + prize.type + '.png'" :is="icon" class="w-24 md:w-40 mx-auto text-gray-200"/>
        
        <button v-if="prize.type !== 'tickets'" class="bg-racing-stars-yellow hover:bg-[#FBE90D]/40 backdrop-blur mt-2 w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-semibold text-black mb-2">
            Claim
        </button>
        <span v-else class="bg-racing-stars-yellow hover:bg-[#FBE90D]/40 backdrop-blur mt-2 w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-semibold text-black mb-2">
            We will be in touch shortly!
        </span>
    </button>

  <tw-modal :show="showQrModal" @close="showQrModal = false" title="Claim Your Prize!" subtitle="Present this QR code to the store teller when asked." :padding="true">
    <qrcode-vue :value="qrcode" :size="200" level="H"  class="mx-auto my-4 border border-white p-4 bg-white"/>
    <button @click="toggleQrModal" class="bg-racing-stars-yellow border border-black rounded-md font-medium text-black p-1 w-full mt-2">Close</button>
  </tw-modal>

</template>

<script>
import { ref } from 'vue'; 
import QrcodeVue from 'qrcode.vue'
import TwModal from '@/Global/Elements/TwModal.vue';
import { GiftIcon } from '@heroicons/vue/outline'
export default {
props: {
  prize: {
    type: String,
    required: true,
  },
  qrcode: {
    type: String,
    required: true,
  },
},

components: {
  QrcodeVue,
  GiftIcon,
},

setup(props) {
  const showQrModal = ref(false);

  const toggleQrModal = () => {
    showQrModal.value = !showQrModal.value;
  };
  
  return {
    showQrModal,
    toggleQrModal,
  };
},
}
</script>
